// extracted by mini-css-extract-plugin
module.exports = {"invitationListItem":"InvitationListItem_invitationListItem__bxGJQ","avatar":"InvitationListItem_avatar__1Cszr","info":"InvitationListItem_info__AuBcj"};